














































































































































import {Emit} from "vue-property-decorator";
import {Stored} from "vue-stored-prop-decorator";
import {Component} from '@/shared/component';
import {AbstractShowVue} from '@/components/Abstract/AbstractShowVue';
import {Projet, Tache, Temp, Token} from '@/models';

import storeProjet from '@/stores/modules/projet';
import storeToken from "@/stores/modules/token";

import CrudProjetEditDialog from '@/components/Crud/Projet/EditDialog.vue';
import CrudDeleteDialog from '@/components/Crud/DeleteDialog.vue';
import CrudTacheList from "@/components/Crud/Tache/List.vue";
import CrudTacheEditDialog from "@/components/Crud/Tache/EditDialog.vue";
import CrudTempList from "@/components/Crud/Temp/List.vue";
import CrudTempEditDialog from "@/components/Crud/Temp/EditDialog.vue";

@Component({
	components: {
		CrudProjetEditDialog,
		CrudDeleteDialog,
		CrudTacheList,
		CrudTacheEditDialog,
		CrudTempList,
		CrudTempEditDialog,
	}
})
export default class CrudProjetShow extends AbstractShowVue<Projet> {

	private imgPath: string = "";

	private editProjet: Projet = null;
	private editTache: Tache = null;
	private editTemp: Temp = null;
	private list;
	private list2;

	@Stored(() => storeToken)
	private token: Token;

	public constructor() {
		super(storeProjet);
	}

	public async mounted(): Promise<void> {
		this.list = this.$refs['list'] as CrudTacheList
		this.list2 = this.$refs['list2'] as CrudTempList
		await super.mounted();
	}

	public async refresh(value: any): Promise<void> {
		await super.refresh(value);

		if (this.item !== null)
		{
			this.imgPath = "/img/files/proprietaire.jpg";

			if (this.$route.name === 'projet-show') {
				this.$route.meta.title = 'Détails  d\'un projet';
			}
		}

	}

	@Emit()
	private onCreate(): void {
		let tache = new Tache()
		tache.projet = this.value
		this.editTache = tache;
	}

	@Emit()
	private onCreateTemp(): void {
		let temp = new Temp()
		temp.client = this.item.client
		temp.projet = this.item
		this.editTemp = temp;
	}

	private get hrefPdf(): string {
		return `${process.env.VUE_APP_BACK_BASE_URL}/pdf/projet/${this.item.id}/false?token=${this.token.id}`;
	}

	private get hrefPdfDetail(): string {
		return `${process.env.VUE_APP_BACK_BASE_URL}/pdf/projet/${this.item.id}/true?token=${this.token.id}`;
	}
}
